import { render, staticRenderFns } from "./NoAuthority.vue?vue&type=template&id=05000baa&scoped=true"
import script from "./NoAuthority.vue?vue&type=script&lang=js"
export * from "./NoAuthority.vue?vue&type=script&lang=js"
import style0 from "./NoAuthority.vue?vue&type=style&index=0&id=05000baa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05000baa",
  null
  
)

export default component.exports